(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/tir-service.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/tir-service.js');
"use strict";


const jupiter = svs.core.jupiter;
const logger = svs.termsIntegrity.logger;

const getCmsDataDocumentAsync = async id => {
  const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
  if (useLegacyJupiterApi) {
    try {
      const options = {
        method: 'GET',
        path: new svs.content.shared.ContentUrlBuilder('id').addParams({
          ids: [id],
          count: 100
        }).build()
      };
      logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
      const _await$jupiter$callAs = await jupiter.callAsync(options),
        response = _await$jupiter$callAs.response;
      logger.debug('Call to getCmsDataDocumentAsync response: ', response);
      return response;
    } catch (error) {
      logger.warn('Error getting CMS Data Async', error);
      return {
        error
      };
    }
  }
  try {
    const client = svs.content.shared.getCmsClient();
    const response = await client.v1.content.getByIds({
      ids: id,
      count: 100
    });
    logger.debug('Call to getCmsDataDocumentAsync response: ', response);
    return response;
  } catch (error) {
    logger.warn('Error getting CMS Data Async (CMS API)', error);
    return {
      error
    };
  }
};

const getCmsDataFolderAsync = async parentId => {
  const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
  if (useLegacyJupiterApi) {
    try {
      const options = {
        method: 'GET',
        path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
          parentId,
          count: 100
        }).build()
      };
      const _await$jupiter$callAs2 = await jupiter.callAsync(options),
        response = _await$jupiter$callAs2.response;
      return response;
    } catch (error) {
      logger.warn('Error getting CMS Data Async', error);
      return {
        error
      };
    }
  }
  try {
    const client = svs.content.shared.getCmsClient();
    const response = await client.v1.content.filter({
      parentIds: parentId,
      count: 100
    });
    return response;
  } catch (error) {
    logger.warn('Error getting CMS Data Async (CMS API)', error);
    return {
      error
    };
  }
};
svs.termsIntegrity.sharedComponents.TirService = {
  getCmsDataDocumentAsync,
  getCmsDataFolderAsync
};

 })(window);